import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Header from "./components/Header/Header.jsx";
import ProductsPage from "./pages/products/ProductsPage.jsx";
import ProductPage from "./pages/products/ProductPage.jsx";
import SuccessOrder from "./components/results/SuccessOrder.jsx";
import SearchResults from "./components/Search/SearchResults.jsx";
import HomePage from "./pages/home/HomePage.jsx";

function AppRoutes() {
    const initializeWithDelay = () => {
        const userAgent = navigator.userAgent || "";

        if (userAgent.includes("Android")) {
            console.log("Android device detected. Initializing with delay...");

            setTimeout(() => {
                console.log("Initialization after delay for Android");
            }, 1000);
        } else {
            console.log("Not an Android device, skipping delay.");
        }
    };

    useEffect(() => {
        try {
            initializeWithDelay();

            const userAgent = navigator.userAgent || "";

            if (userAgent.includes("iPhone")) {
                window.disableWebkitEnterFullscreen = function () {
                    console.warn("disableWebkitEnterFullscreen was called but does nothing.");
                };
            }
        } catch (error) {
            if (error.message.includes("Method not found")) {
                console.warn("Method not found", error);
            } else {
                console.warn("AppRouter useEffect error", error);
            }
        }
    }, []);

    return (
        <div>
            <div>
                    <Header />
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/products/:category/:subcategory1?/:subcategory2?" element={<ProductsPage />} />
                        <Route path="/product/:productid" element={<ProductPage />} />
                        <Route path="/purchased" element={<SuccessOrder />} />
                        <Route path="/search" element={<SearchResults />} />
                    </Routes>
            </div>
        </div>
    );
}

export default AppRoutes;